// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.OneTimeRenterPaymentWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { OneTimeRenterPaymentWebApiRequestDto } from '../..';

export const OneTimeRenterPaymentWebApiHandler_oneTimeRenterPayment_Path = '/api/web/v1/oneTimeRenterPayment';

/**
 * One Time Renter Payment
 */
export const OneTimeRenterPaymentWebApiHandler_oneTimeRenterPayment = (
  postData: OneTimeRenterPaymentWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, OneTimeRenterPaymentWebApiRequestDto, void>(
    {
      endpoint: OneTimeRenterPaymentWebApiHandler_oneTimeRenterPayment_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
